import React from "react";
import { useFlags } from "launchdarkly-react-client-sdk";
import lowPerformerIcon from "../assets/star-rating-low-performer.svg";
import highPerformerIcon from "../assets/star-rating-high-performer.svg";
import { useTranslate } from "../helpers/intlHooks";
import { CollapsibleBox, StarRating } from ".";
import { StarRating as StarRatingType } from "../@types";
import { hideStarRatings } from "../helpers";

interface PlanOverallStarRatingProps {
  starRating?: StarRatingType;
  highPerforming: boolean;
  lowPerforming: boolean;
  planYear: string;
}

const PlanOverallStarRating: React.FunctionComponent<PlanOverallStarRatingProps> = props => {
  const t = useTranslate();
  const { feEnableStarRatings, mctCurrentPlanYear } = useFlags();
  const showStarRatings = !hideStarRatings(props.planYear, {
    feEnableStarRatings,
    mctCurrentPlanYear,
  });

  return (
    <div className="PlanStarRatingRow">
      {showStarRatings && props.lowPerforming && (
        <div className="ds-u-display--flex ds-u-margin-bottom--1 ds-u-margin-x--1">
          <img
            src={lowPerformerIcon}
            className="StarRating__performerIcon ds-u-margin-right--1"
            alt={t("plan_stars.alt.low_performer")}
          />
          <span>{t("plan_stars.low_performer")}</span>
        </div>
      )}

      {showStarRatings && props.highPerforming && (
        <div className="ds-u-display--flex ds-u-margin-bottom--1 ds-u-margin-x--1">
          <img
            src={highPerformerIcon}
            className="StarRating__performerIcon ds-u-margin-right--1"
            alt={t("plan_stars.alt.high_performer")}
          />
          <span>{t("plan_stars.high_performer")}</span>
        </div>
      )}

      <div className="PlanStarRatingRow__header PlanStarRatingRow__header--blue ds-u-display--flex ds-u-flex-wrap--wrap ds-u-justify-content--between">
        <div>
          <h2 className="PlanStarRatingRow__label">
            <CollapsibleBox
              labelId={"plan_stars.overall"}
              titleClassname="PlanDetailList__header"
              contentClassname="PlanDetailList__definition"
              tealiumProps={{
                event_action: "Plan Details - Star Ratings",
                event_label: "Toggle - Overall",
              }}
            >
              <p>{t("plan_stars.overall_basis")}</p>
            </CollapsibleBox>
          </h2>
        </div>
        <StarRating
          includeLabel={false}
          highPerforming={props.highPerforming}
          lowPerforming={false}
          stars={props.starRating}
          planYear={props.planYear}
        />
      </div>
    </div>
  );
};

export default PlanOverallStarRating;
